/*
import React from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import LABEL from '../../../business-const/Label/Label'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

//import {
//    RichTextEditor
//} from '../../../business-components/RichTextEditor/RichTextEditor'

import {
    RichTextEditorPadrao
} from '../../../business-components/RichTextEditor/RichTextEditorPadrao'



const CadastroFormObjetivos = ( { values, handleSubmit, setFieldValue } ) => {

    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <DivForm>
                <GridContainer>
                    <GridItem12>
                        <CardGridEntradaDados>
                            <CardGridDivHeaderEntradaDados>
                                <CardGridDivEntradaDados>
                                    {LABEL.objetivosPrincipaisPreocupacoes}
                                </CardGridDivEntradaDados>
                            </CardGridDivHeaderEntradaDados>

                            <CardGridDivBodyEntradaDados>
                                <GridContainer>
                                    <GridItem12>
                                        {/*
                                        <RichTextEditor
                                            content={values.objetivosPrincipaisPreocupacoes}
                                            handleContentChange={(content) =>
                                                setFieldValue(
                                                    "objetivosPrincipaisPreocupacoes",
                                                    content
                                                )
                                            }
                                        />
                                        *//*}
                                        <RichTextEditorPadrao
                                            name={'objetivosPrincipaisPreocupacoes'}
                                            content={values.objetivosPrincipaisPreocupacoes}
                                            setFieldValue={setFieldValue}
                                        />
                                    </GridItem12>
                                </GridContainer>
                            </CardGridDivBodyEntradaDados>
                        </CardGridEntradaDados>
                    </GridItem12>
                </GridContainer>
            </DivForm>
        </ValidatorForm>
    )
}

export default CadastroFormObjetivos
*/
import React from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import { FieldArray } from 'formik'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    nvl,
} from '../../../business-components/Formata/Formata'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem2,
    GridItem3,
    GridItem8,
    GridItem9,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    TextValidatorText,
} from '../../../business-components/TextValidator/TextValidator'

//import {
//    RichTextEditor
//} from '../../../business-components/RichTextEditor/RichTextEditor'

import {
    RichTextEditorPadrao
} from '../../../business-components/RichTextEditor/RichTextEditorPadrao'

import {
    IconButtonClearEntradaDados,
    IconButtonImprimir,
    IconButtonMoveParaCimaParaBaixo,
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha,
    ButtonAlterarTituloPagina
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import EstudoFormObjetivos from '../estudo-form/EstudoFormObjetivos'

import EstudoReportContainer from '../estudo-report/EstudoReportContainer'

import EstudoReportPage from '../estudo-report/EstudoReportPage'


const CadastroFormObjetivos = ( { variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, vars } ) => {

    const report = true

    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <FieldArray name="objetivosPrincipaisPreocupacoesPFCMLP">
                {(arrayHelpers) => (
                    <DivForm>
                        <DivForm>
                            {values.objetivosPrincipaisPreocupacoesPFCMLP?.map((item, ind) => {

                                return (
                                    <GridContainer
                                        key={ind}
                                    >
                                        <GridItem12>
                                            <CardGridEntradaDados>
                                                <CardGridDivHeaderEntradaDados>
                                                    <CardGridDivEntradaDados>
                                                        <GridContainer>
                                                            <GridItem9>
                                                                {LABEL.pagina + ' ' + (ind + 1) + ': ' +
                                                                    (
                                                                        item.tituloPagina
                                                                            ?
                                                                                item.tituloPagina
                                                                            :
                                                                                LABEL.objetivosPrincipaisPreocupacoesPFCMLP
                                                                    )
                                                                }
                                                            </GridItem9>

                                                            <GridItem3>
                                                                <CustomizedDialogsPopup
                                                                    maxWidth='xl'
                                                                    popupTitle={LABEL.previewRelatorio}
                                                                    tooltipTitle={LABEL.previewRelatorio}
                                                                    PopupButton={IconButtonImprimir}
                                                                    bgDefault={true}
                                                                    popupComponent={
                                                                        <EstudoReportContainer
                                                                            values={values}
                                                                            naoPermitirImprimir={true}
                                                                            conteudo={
                                                                                values.objetivosPrincipaisPreocupacoesPFCMLP?.map((item, ind) => (
                                                                                    item.richText && item.richText !== HARDCODE.richTextEditorVazio && (
                                                                                        <EstudoReportPage
                                                                                            key={ind}
                                                                                            variaveisGlobais={variaveisGlobais}
                                                                                            values={values}
                                                                                            vars={vars}
                                                                                            cabecalho={nvl(item.tituloPagina, LABEL.objetivosPrincipaisPreocupacoesPFCMLP)}
                                                                                            conteudo={
                                                                                                <EstudoFormObjetivos
                                                                                                    values={values}
                                                                                                    report={report}
                                                                                                    indPagina={ind}
                                                                                                />
                                                                                            }
                                                                                            pagina={''}
                                                                                        />
                                                                                    )
                                                                                ))
                                                                            }
                                                                        />
                                                                    }
                                                                />

                                                                <GridContainer>
                                                                    <GridItem8
                                                                        className='mt--1 mb--2'
                                                                    >
                                                                        <CustomizedDialogsPopup
                                                                            maxWidth='md'
                                                                            popupTitle={LABEL.alterarTituloPagina + ' ' + (ind + 1)}
                                                                            tooltipTitle={LABEL.alterarTituloPagina}
                                                                            PopupButton={ButtonAlterarTituloPagina}
                                                                            //bgDefault={true}
                                                                            popupComponent={
                                                                                <GridContainer>
                                                                                    <GridItem11>
                                                                                        <TextValidatorText
                                                                                            name={`objetivosPrincipaisPreocupacoesPFCMLP[${ind}].tituloPagina`}
                                                                                            label={LABEL.tituloPagina}
                                                                                            value={item.tituloPagina || ''}
                                                                                            onChange={handleChange}
                                                                                            tamMax={TAMMAX.tituloPagina}
                                                                                            notToUpperCase={true}
                                                                                        />
                                                                                    </GridItem11>
                                                                                </GridContainer>
                                                                            }
                                                                        />
                                                                    </GridItem8>

                                                                    <GridItem2
                                                                        align='right'
                                                                    >
                                                                        <IconButtonMoveParaCimaParaBaixo
                                                                            array={values.objetivosPrincipaisPreocupacoesPFCMLP}
                                                                            nomeArray={'objetivosPrincipaisPreocupacoesPFCMLP'}
                                                                            setFieldValue={setFieldValue}
                                                                            ind={ind}
                                                                        />
                                                                    </GridItem2>

                                                                    <GridItem2
                                                                        className='mt--2'
                                                                    >
                                                                        <IconButtonClearEntradaDados
                                                                            onClick={() =>
                                                                                arrayHelpers.remove(ind)
                                                                            }
                                                                        />
                                                                    </GridItem2>
                                                                </GridContainer>
                                                            </GridItem3>
                                                        </GridContainer>
                                                    </CardGridDivEntradaDados>
                                                </CardGridDivHeaderEntradaDados>

                                                <CardGridDivBodyEntradaDados>
                                                    <GridContainer>
                                                        <GridItem11>
                                                            {/*
                                                            <RichTextEditor
                                                                content={item}
                                                                handleContentChange={(content) =>
                                                                    setFieldValue(
                                                                        `consideracaoFinal[${ind}]`,
                                                                        content
                                                                    )
                                                                }
                                                            />
                                                            */}
                                                            <RichTextEditorPadrao
                                                                name={`objetivosPrincipaisPreocupacoesPFCMLP[${ind}].richText`}
                                                                content={item.richText}
                                                                setFieldValue={setFieldValue}
                                                            />
                                                        </GridItem11>
                                                    </GridContainer>
                                                </CardGridDivBodyEntradaDados>
                                            </CardGridEntradaDados>
                                        </GridItem12>
                                    </GridContainer>
                                )
                            })}
                        </DivForm>

                        <GridContainer>
                            <ButtonIncluirLinha
                                label={LABEL.buttonIncluirConsideracaoFinal} 
                                onClick={() => 
                                    arrayHelpers.push({
                                        tituloPagina: '',
                                        richText: '',
                                    })
                                }
                            />
                        </GridContainer>
                    </DivForm>
                )}
            </FieldArray>
        </ValidatorForm>
    )
}

export default CadastroFormObjetivos